import { render, staticRenderFns } from "./wxmsgTemplate.vue?vue&type=template&id=61874fbc&"
import script from "./wxmsgTemplate.vue?vue&type=script&lang=js&"
export * from "./wxmsgTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports